export default function validationCriteresRecherche(criteresRecherche, errors) {
  if (!criteresRecherche.fromDate) {
    errors.push({
      message: 'ecranAjoutFaces.rechercheContent.errors.datesRequired',
    });
  }
  if (criteresRecherche.toDate && criteresRecherche.fromDate > criteresRecherche.toDate) {
    errors.push({
      message: 'ecranAjoutFaces.rechercheContent.errors.dateDebutGreaterDateFin',
    });
  }
}
